import React, { FC } from "react"

import { IconBaseProps } from "./Base"
import Box from "../atoms/box/Box"

const Discord: FC<IconBaseProps> = ({
  width = "100%",
  height = "100%",
  ...props
}) => {
  return (
    <Box {...props}>
      <svg
        role="img"
        aria-label="Electric Impact on Discord"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 0C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.895431 24 3.22133e-08 23.1046 0 22V2C0 0.895431 0.895431 3.22128e-08 2 0H22ZM14.2881 5.76074C14.2673 5.75693 14.2461 5.76611 14.2354 5.78516C14.0947 6.03528 13.9391 6.36173 13.8301 6.61816C12.6003 6.43405 11.3764 6.43405 10.1719 6.61816C10.0628 6.35605 9.90198 6.03526 9.76074 5.78516C9.75002 5.76674 9.72883 5.75757 9.70801 5.76074C8.56528 5.95756 7.47156 6.30197 6.45117 6.77051C6.4424 6.77432 6.43469 6.78086 6.42969 6.78906C4.3556 9.88782 3.7877 12.9104 4.06641 15.8955C4.06767 15.9101 4.07556 15.9247 4.08691 15.9336C5.45537 16.9385 6.78106 17.5487 8.08203 17.9531C8.10285 17.9595 8.12542 17.9517 8.13867 17.9346C8.44643 17.5143 8.72084 17.0705 8.95605 16.6045C8.96955 16.5773 8.95594 16.5449 8.92773 16.5342C8.49266 16.3691 8.0782 16.168 7.67969 15.9395C7.64829 15.921 7.64585 15.8761 7.6748 15.8545C7.75868 15.7916 7.84276 15.7262 7.92285 15.6602C7.93733 15.6482 7.95762 15.6457 7.97461 15.6533C10.593 16.8487 13.4281 16.8488 16.0156 15.6533C16.0325 15.6453 16.0524 15.6474 16.0674 15.6592C16.1475 15.7252 16.2319 15.7916 16.3164 15.8545C16.3452 15.8761 16.343 15.9211 16.3115 15.9395C15.9131 16.1724 15.4991 16.3698 15.0635 16.5342C15.0352 16.5449 15.0224 16.5772 15.0361 16.6045C15.2764 17.0698 15.5505 17.5133 15.8525 17.9336C15.8652 17.9514 15.8884 17.9595 15.9092 17.9531C17.2163 17.5487 18.5418 16.9384 19.9102 15.9336C19.9221 15.9248 19.9294 15.911 19.9307 15.8965C20.2643 12.4452 19.3723 9.44673 17.5654 6.78906C17.561 6.78043 17.5535 6.77428 17.5449 6.77051C16.5252 6.30262 15.4314 5.9582 14.2881 5.76074ZM9.34668 10.8525C10.1539 10.8525 10.7968 11.5833 10.7842 12.4658C10.784 13.3545 10.1475 14.0781 9.34668 14.0781C8.55846 14.0781 7.90939 13.3545 7.90918 12.4658C7.90918 11.577 8.54573 10.8525 9.34668 10.8525ZM14.6631 10.8525C15.4703 10.8525 16.1142 11.5833 16.1016 12.4658C16.1014 13.3545 15.4702 14.0781 14.6631 14.0781C13.8749 14.0781 13.2258 13.3544 13.2256 12.4658C13.2256 11.577 13.8622 10.8526 14.6631 10.8525Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  )
}

export default Discord
